export const testimonials = [
  {
    id: 1,
    name: '漫画迷小王',
    avatar: 'https://readdy.ai/api/search-image?query=A%20young%20Asian%20male%20portrait%20avatar%2C%20casual%20style%2C%20friendly%20smile%2C%20simple%20dark%20background%2C%20clean%20minimal%20portrait%20photography%2C%20soft%20lighting&width=200&height=200&seq=testimonial-avatar-01&orientation=squarish',
    rating: 5,
    role: '忠实读者 · 3年',
    comment: '韩漫网真的是我做喜欢的漫画平台！漫画资源超级全，更新速度也很快。最重要的是完全免费，不用注册就能看，太方便了。画质清晰，阅读体验一级棒。',
  },
  {
    id: 2,
    name: '漫画达人小李',
    avatar: 'https://readdy.ai/api/search-image?query=A%20young%20Asian%20female%20portrait%20avatar%2C%20modern%20casual%20look%2C%20warm%20smile%2C%20simple%20dark%20background%2C%20clean%20minimal%20portrait%20photography%2C%20soft%20natural%20lighting&width=200&height=200&seq=testimonial-avatar-02&orientation=squarish',
    rating: 5,
    role: '漫画博主',
    comment: '作为一个看了十年韩漫的老读者，我真的要吹爆韩漫网。分类做得很细致，找漫画特别方便。而且更新列表很及时，新章节一出来就能看到，不用到处找资源。',
  },
  {
    id: 3,
    name: '追更狂人阿杰',
    avatar: 'https://readdy.ai/api/search-image?query=A%20young%20Asian%20male%20portrait%20avatar%2C%20stylish%20casual%20look%2C%20confident%20expression%2C%20simple%20dark%20background%2C%20clean%20minimal%20portrait%20photography%2C%20dramatic%20lighting&width=200&height=200&seq=testimonial-avatar-03&orientation=squarish',
    rating: 5,
    role: '重度用户 · 5年',
    comment: '从大学开始就在韩漫网看漫画，到现在已经五年了。推荐给了身边所有喜欢漫画的朋友，大家都很满意。希望韩漫网越做越好，继续为我们带来更多优质的漫画作品！',
  },
  {
    id: 4,
    name: '二次元少女',
    avatar: 'https://readdy.ai/api/search-image?query=A%20young%20Asian%20female%20portrait%20avatar%2C%20cute%20style%2C%20bright%20smile%2C%20simple%20dark%20background%2C%20clean%20minimal%20portrait%20photography%2C%20soft%20glamour%20lighting&width=200&height=200&seq=testimonial-avatar-04&orientation=squarish',
    rating: 5,
    role: '资深漫迷',
    comment: '韩漫网页面设计得很好看，手机和电脑都能顺畅阅读。漫画种类也很丰富，从热血到耽美，什么类型都有。每天都忍不住上来刷一刷有没有新更新！',
  },
  {
    id: 5,
    name: '书虫小陈',
    avatar: 'https://readdy.ai/api/search-image?query=A%20young%20Asian%20male%20portrait%20avatar%2C%20intellectual%20look%20with%20glasses%2C%20gentle%20smile%2C%20simple%20dark%20background%2C%20clean%20minimal%20portrait%20photography%2C%20warm%20lighting&width=200&height=200&seq=testimonial-avatar-05&orientation=squarish',
    rating: 4,
    role: '新用户 · 1个月',
    comment: '朋友推荐来的，一开始还担心是骗人的网站，没想到真的全部免费！而且漫画质量都很高，翻译也很到位。已经成功安利给好几个同事了，大家都说好。',
  },
  {
    id: 6,
    name: '夜猫子小雯',
    avatar: 'https://readdy.ai/api/search-image?query=A%20young%20Asian%20female%20portrait%20avatar%2C%20night%20owl%20vibe%2C%20mysterious%20expression%2C%20simple%20dark%20background%2C%20clean%20minimal%20portrait%20photography%2C%20moody%20lighting&width=200&height=200&seq=testimonial-avatar-06&orientation=squarish',
    rating: 5,
    role: '夜班族 · 2年',
    comment: '作为一个夜班族，韩漫网是我每个深夜最好的陪伴。恐怖和悬疑分类是我的最爱，看得根本停不下来！而且夜间模式对眼睛很友好，推荐给所有夜猫子。',
  },
];